import AnticipationSupplement from "slotworks/model/gameplay/supplements/anticipation-supplement";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";
import FreespinSymbolSubstituteSupplement from "slotworks/model/gameplay/supplements/freespin-symbol-substitute-supplement";
import GridOnlySupplement from "slotworks/model/gameplay/supplements/grid-only-supplement";

export class DataProcessorSupplementCollection {
    private dataProcessorSupplements: DataProcessorSupplement[] = [FreespinSymbolSubstituteSupplement, AnticipationSupplement, GridOnlySupplement];

    public addAfterStandard(dataProcessorSupplement: DataProcessorSupplement) {
        this.dataProcessorSupplements.push(dataProcessorSupplement);
    }

    public addBeforeStandard(dataProcessorSupplement: DataProcessorSupplement) {
        this.dataProcessorSupplements.unshift(dataProcessorSupplement);
    }

    public remove(dataProcessorSupplement: DataProcessorSupplement) {
        this.dataProcessorSupplements.splice(this.dataProcessorSupplements.indexOf(dataProcessorSupplement), 1);
    }

    public get() {
        return this.dataProcessorSupplements;
    }
}
